/*
 *  Quantities used by both the server and the client,
 *  but not appropriate for the config file.  (We want the value set in git.)
 */
export const debugAuth = false;
// Production value:  24 hours in milliseconds
export const COOKIE_MAX_AGE = debugAuth ? 30 * 1000 : 24 * 60 * 60 * 1000;
